var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import Icon, { IconName } from '../../components/Icon';
import { Elevation } from '../../theme/elevation';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import { SharedPropsContext } from './';
var ModalContainer = function (_a) {
    var name = _a.name, children = _a.children, onCloseClick = _a.onCloseClick, className = _a.className, htmlProps = __rest(_a, ["name", "children", "onCloseClick", "className"]);
    var _b = useContext(SharedPropsContext), staticSize = _b.staticSize, parentName = _b.name, themeFamily = _b.themeFamily;
    return (_jsxs(Container, __assign({}, htmlProps, { themeFamily: themeFamily, "data-testid": (name || parentName) + "-modal-container", className: className, statiSize: staticSize }, { children: [_jsx(CloseIconContainer, { children: !!onCloseClick && (_jsx(StyledIcon, { themeFamily: themeFamily, name: IconName.DELETE, onClick: onCloseClick }, void 0)) }, void 0), children] }), void 0));
};
export default ModalContainer;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n  overflow: hidden;\n  box-shadow: ", ";\n  background-color: ", ";\n  border-radius: 18px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"], ["\n  ", "\n  display: inline-block;\n  overflow: hidden;\n  box-shadow: ", ";\n  background-color: ", ";\n  border-radius: 18px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"])), getThemeBreakpoints('modal'), function (_a) {
    var theme = _a.theme;
    return theme.elevation[Elevation.DEPTH2];
}, function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return theme.families.modal[themeFamily].main;
});
var CloseIconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  flex-shrink: 0;\n  height: 48px;\n"], ["\n  position: relative;\n  flex-shrink: 0;\n  height: 48px;\n"])));
var StyledIcon = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 24px;\n  position: absolute;\n  top: 24px;\n  right: 24px;\n"], ["\n  color: ", ";\n  font-size: 24px;\n  position: absolute;\n  top: 24px;\n  right: 24px;\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return theme.families.modal[themeFamily].disabledText;
});
var templateObject_1, templateObject_2, templateObject_3;
